import React from 'react';
import ReactDOM from 'react-dom';
import types from './popup_types';
import './style.scss';

const WRAPPER_CLASS = 'f-popup-wrapper';

export function onModalClick(e, modalClose, closePopup) {

    if (!modalClose) {
        return;
    }

    if (e.target.className.indexOf(WRAPPER_CLASS) > -1) {
        closePopup();
    }
}

function PopupGenerator({closePopup, name = '', title = '', children, modalVisible = true, modalClose = true, brighten = false, layout = 'base'}) {
    let modalClass = modalClose || modalVisible ? ' modal' : '';

    if (modalVisible) {
        if (brighten) {
            modalClass += ' brighten';
        } else {
            modalClass += ' darken';
        }
    }

    const wrapperClass = `${WRAPPER_CLASS}${modalClass}`,
        popupClass = `popup-${layout} popup-${name}`,
        type = types.hasOwnProperty(layout) ? layout : 'base';

    return (
        <div className={wrapperClass} onClick={(e) => onModalClick(e, modalClose, closePopup)}>
            <div className="scroller">
                <button className="btn-close outside-close" onClick={closePopup}>&times;</button>
                {types[type]({popupClass, closePopup, title, children})}
            </div>
        </div>
    );
}

export default class Popup extends React.Component {

    constructor() {
        super();

        this.onEscape = this.onEscape.bind(this);
    }

    componentWillMount() {
        this.setEntryPoint(this.props);
    }

    componentWillReceiveProps(props) {
        this.setEntryPoint(props);
    }

    setEntryPoint(props) {
        if (props.isOpen) {

            const layout = props.layout || 'base';

            if (!this.entryPoint) {
                this.createEntryPoint(props.name, layout);
            }

            if (props.noScroll && document) {
                document.body.classList.add('no-scroll');
            }

            window.addEventListener('keyup', this.onEscape);

            this.renderPopup(props);
        } else {

            this.closePopup = props.closePopup;

            if (this.entryPoint) {
                this.entryPoint.classList.remove('shown');
            }
            setTimeout(() => {
                if (this.entryPoint && document) {
                    ReactDOM.unmountComponentAtNode(this.entryPoint);
                    document.body.removeChild(this.entryPoint);
                    document.body.classList.remove('no-scroll');
                }
                delete this.entryPoint;
            }, 500);
        }
    }

    onEscape(e) {

        if (e.keyCode === 27 || e.which === 27 || e.code === 'Escape' || e.key === 'Escape') {
            this.closePopup && this.closePopup();
            window.removeEventListener('keyup', this.onEscape);
        }
    }

    createEntryPoint(name, layout) {
        if (document) {
            this.entryPoint = document.createElement('div');
            this.entryPoint.setAttribute('class', `popup-root ${name} ${layout}`);
            document.body.appendChild(this.entryPoint);
            setTimeout(() => this.entryPoint.classList.add('shown'), 0);
        }
    }

    renderPopup(props) {
        const Generator = props.customGenerator || PopupGenerator;

        ReactDOM.unstable_renderSubtreeIntoContainer(props.parent, <Generator {...props}/>, this.entryPoint);
    }

    render() {
        return null;
    }
}


// WEBPACK FOOTER //
// ./src/fPopup/index.js